// src/pages/ClientData/components/ProcessCard.js
import React, { useState } from 'react';
import CollapsibleSection from './CollapsibleSection';
import MovementsSection from './MovementsSection';

const ProcessCard = ({
  processo,
  detail,
  detailLoading,
  detailError,
  onLoadDetail,
  movimentosState,
  movementsLoading,
  movementsError,
  onLoadMovements,
  movementFiles,
  movementFilesLoading,
  movementFilesErrors,
  onLoadFiles,
  fileTranscriptions,
  fileTranscriptionLoading,
  fileTranscriptionErrors,
  fileSaving,
  onSetFileTranscriptionText,
  onTranscreverFicheiro,
  onSalvarFicheiro
}) => {
  const codigoProcesso = processo['Cod. Processo'];
  const [open, setOpen] = useState(false);

  const handleToggle = (novoEstado) => {
    setOpen(novoEstado);
    if (novoEstado && !detail && !detailLoading) {
      onLoadDetail(codigoProcesso);
    }
  };

  const dadosProcesso = detail || processo;

  return (
    <CollapsibleSection
      title={codigoProcesso}
      icon="📁"
      badge={processo['Estado']}
      level={1}
      open={open}
      onToggle={handleToggle}
    >
      {detailLoading && <div className="cd-inline-loading">⏳ A carregar detalhes do processo...</div>}
      {detailError && <div className="error-message">{detailError}</div>}

      <div className="data-fields">
        {Object.entries(dadosProcesso).map(([key, value]) => {
          if (value === null || value === undefined || value === '') return null;
          return (
            <div className="data-field" key={key}>
              <div className="field-key">{key}</div>
              <div className="field-value">{String(value)}</div>
            </div>
          );
        })}
      </div>

      <MovementsSection
        processCode={codigoProcesso}
        movimentosState={movimentosState}
        loading={movementsLoading}
        error={movementsError}
        onLoadMovements={onLoadMovements}
        movementFiles={movementFiles}
        movementFilesLoading={movementFilesLoading}
        movementFilesErrors={movementFilesErrors}
        onLoadFiles={onLoadFiles}
        fileTranscriptions={fileTranscriptions}
        fileTranscriptionLoading={fileTranscriptionLoading}
        fileTranscriptionErrors={fileTranscriptionErrors}
        fileSaving={fileSaving}
        onSetFileTranscriptionText={onSetFileTranscriptionText}
        onTranscreverFicheiro={onTranscreverFicheiro}
        onSalvarFicheiro={onSalvarFicheiro}
      />
    </CollapsibleSection>
  );
};

export default ProcessCard;
